export const PtoTypeChoices: { [keys: string]: string } = {
  vacation: "Vacation",
  office_closure: "Office Closure",
  sick: "Sick",
  unplanned: "Unplanned (<72 hours)",
  other: "Other",
  training_hours: "Training hours",
};
